export default __webpack_public_path__ + "static/media/wood.2f4120d3.svg";